import { Navigate } from "react-router";

import useHasMultientityDashboard from "@/hooks/useHasMultientityDashboard";

function DashboardIndex() {
  const hasMultientityDashboard = useHasMultientityDashboard();

  return (
    <Navigate
      to={
        hasMultientityDashboard
          ? "/dashboard/multientity"
          : "/dashboard/overview"
      }
      replace
    />
  );
}

export default DashboardIndex;
